import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Board from '../../../components/Board';
import { useParams } from 'react-router-dom';

function AdminCRM() {

    const { userId } = useParams()

    return (
        <DndProvider backend={HTML5Backend}>
            <Board userId={userId} />
        </DndProvider>
    );
}

export default AdminCRM;